import React from 'react';
import Formulario from "./components/Formulario";
import Lista from "./components/Lista";

const CosteoRutas = props => {
    const path = props.match.path;
    return (
        <React.Fragment>
            {(path === '/costeorutas/nuevo' || path === '/costeorutas/edit/:id') && <Formulario {...props}/>}
            {path === '/costeorutas' && <Lista {...props}/>}
        </React.Fragment>
    );
};

export default CosteoRutas;
